
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import { createAmpOfferInstance, HomeOffer } from '@alao-frontend/core'
import BlackFridayHeader from '@/components/black-friday/BlackFridayHeader.vue'
import BlackFridayEmailForm from '@/components/black-friday/BlackFridayEmailForm.vue'
import BlackFridayOfferSlider from '@/components/black-friday/BlackFridayOfferSlider.vue'
import Partners from '@/components/black-friday/Partners.vue'
import BlackFridayHiw from '@/components/black-friday/BlackFridayHiw.vue'
import BlackFridayFeatureBanner from '@/components/black-friday/BlackFridayFeatureBanner.vue'
import BlackFridayDealsSection from '@/components/black-friday/BlackFridayDealsSection.vue'
import BlackFridayMoreDeals from '@/components/black-friday/BlackFridayMoreDeals.vue'
import Footer from '@/components/black-friday/Footer.vue'
import BlackFridayClientFeedback from '@/components/black-friday/BlackFridayClientFeedback.vue'
import SaveRouteMixin from '~/mixins/save-route.mixin'
import { OnMounted, WithHead } from '~/core/vue.types'
import { $api } from '~/plugins/axios'
import { NotifiesOfferType } from '~/services/notifier.service'
import BlackFridayPageBody from '~/components/black-friday/BlackFridayPageBody.vue'
import { useSEOMetaComposer } from '~/composables/seo.composable'
import BPSection from '~/components/promos/black-promo/snippets/BPSection.vue'
import BPPlans from '~/components/promos/black-promo/BPDeals/BPPlans.vue'
import BFFaq from '~/components/black-friday/BFFaq.vue'

@Component({
  nuxtI18n: {
    paths: {
      en: '/black-friday/internet-plans/',
      de: '/black-friday/internet-abos/',
      fr: '/black-friday/abonnements-internet/',
    },
  },
  components: {
    BlackFridayPageBody,
    BlackFridayHeader,
    BlackFridayEmailForm,
    BlackFridayOfferSlider,
    Partners,
    BlackFridayHiw,
    BlackFridayFeatureBanner,
    BlackFridayDealsSection,
    BlackFridayMoreDeals,
    Footer,
    BlackFridayClientFeedback,
    BPSection,
    BPPlans,
    BFFaq,
  },
  mixins: [SaveRouteMixin],
})
export default class BlackFridayInternetPlansPage
  extends Vue
  implements OnMounted, WithHead {
  private isOffersLoading = true
  private offers: HomeOffer[] = []
  private offerType = NotifiesOfferType.HOME_OFFER

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.blackFriday.internetPlans.title').toString(),
        description: this.$t(
          'head.meta.blackFriday.internetPlans.description',
        ).toString(),
        route: { name: 'black-friday-internet-plans' },
      },
    )
  }

  get moreDealsLinks (): { text: string, url: string }[] {
    return [
      {
        text: this.$t('blackFriday.moreDealsBanner.mobilePlans') as string,
        url: this.localePath('black-friday-mobile-plans'),
      },
      {
        text: this.$t('blackFriday.moreDealsBanner.blog') as string,
        url: this.localePath({
          name: 'blogs-slug',
          params: {
            slug: 'black-friday-tips',
          },
        }),
      },
    ]
  }

  async mounted (): Promise<void> {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'Black Friday page',
    })
    try {
      this.offers = (await $api.PublicOfferService.searchOffers({
        product_type: 'home',
        limit: 5,
      })).items.map(item => createAmpOfferInstance(item))

      this.isOffersLoading = false
    } catch (error:any) {
      this.$notify({
        title: 'Error',
        message: error.message,
        duration: 3000,
      })
    }
  }
}
